import { AnyAction } from 'redux';
import { createReducer } from 'redux-create-reducer';

import {
  ClickAway,
  FetchAllProductsInstances,
  SetBootstrapConfig,
  SetNavigateConfig,
  FetchAllUsers,
  FetchFeatureFlags,
  FetchAllGroups,
  CloseGroupsGeneralNetworkErrorBanner,
  SetNavigateFn,
  FetchAllRoles,
} from './actions';
import { ICommon } from '../../interfaces/ICommon';
import { SetCurrentUserId } from '../users/actions';

/**
 * Please make sure that if you are adding
 * an array to the state,
 *
 * Use an object that includes -
 * {items: typeof [], loading: false, error: null}
 * as the initial state (and optionally didFetch/didRetrieved).
 *
 * Note 'allUsers' and 'featureFlags' to
 * 'allRoles' and 'allGroups' for exmaple
 *
 * Thanks!
 */
export const initialState: ICommon = {
  bootstrap: {
    isStandalone: false,
    basePath: null,
  },
  navigation: {
    enterpriseId: null,
    pathname: null,
    redirectPath: null,
    navigateFn: () => null,
  },
  auth: {
    signOutCallbackFn: () => null,
    userId: null,
  },
  productInstances: {
    items: [],
    loading: false,
  },
  allUsers: [],
  allUsersLoading: false,
  allUsersRetrieved: false,
  allRoles: {
    items: [],
    error: null,
    loading: false,
  },
  allGroups: {
    items: [],
    error: null,
    loading: false,
  },
  featureFlags: [],
  featureFlagsRetrieved: false,
};

export default createReducer(initialState, {
  [SetBootstrapConfig.TYPE]: (state: ICommon, { payload }: AnyAction) => ({
    ...state,
    bootstrap: {
      ...state.bootstrap,
      ...payload,
    },
  }),

  [SetNavigateConfig.TYPE]: (state: ICommon, { payload }: AnyAction) => ({
    ...state,
    navigation: {
      ...state.navigation,
      ...payload,
    },
  }),

  [SetNavigateFn.TYPE]: (state: ICommon, { payload }: AnyAction) => ({
    ...state,
    navigation: {
      ...state.navigation,
      navigateFn: payload,
    },
  }),

  [ClickAway.TYPE]: (
    state: ICommon,
    { payload: { path, signOutCallback } }: AnyAction
  ) => ({
    ...state,
    navigation: {
      ...state.navigation,
      redirectPath: `${path}?enterpriseId=${state.navigation.enterpriseId}`,
    },
    auth: {
      ...state.auth,
      signOutCallbackFn: signOutCallback,
    },
  }),

  [FetchAllProductsInstances.Pending.TYPE]: (state: ICommon) => ({
    ...state,
    productInstances: {
      items: [],
      loading: true,
    },
  }),
  [FetchAllProductsInstances.Success.TYPE]: (
    state: ICommon,
    { payload }: AnyAction
  ) => ({
    ...state,
    productInstances: {
      items: payload,
      loading: false,
    },
  }),

  [FetchAllUsers.Pending.TYPE]: (state: ICommon) => ({
    ...state,
    allUsersLoading: true,
    allUsersRetrieved: false,
  }),
  [FetchAllUsers.Success.TYPE]: (state: ICommon, { payload }: AnyAction) => ({
    ...state,
    allUsers: payload,
    allUsersLoading: false,
    allUsersRetrieved: true,
  }),
  [FetchAllUsers.Error.TYPE]: (state: ICommon, { payload }: AnyAction) => ({
    ...state,
    allUsers: [],
    allUsersLoading: false,
    allUsersRetrieved: false,
  }),

  [FetchAllGroups.Pending.TYPE]: (state: ICommon) => ({
    ...state,
    allGroups: {
      ...state.allGroups,
      loading: true,
    },
  }),
  [FetchAllGroups.Success.TYPE]: (state: ICommon, { payload }: AnyAction) => ({
    ...state,
    allGroups: {
      items: payload,
      error: null,
      loading: false,
    },
  }),

  [FetchAllRoles.Pending.TYPE]: (state: ICommon) => ({
    ...state,
    allRoles: {
      ...state.allRoles,
      loading: true,
      error: null,
    },
  }),

  [FetchAllRoles.Success.TYPE]: (state: ICommon, { payload }: AnyAction) => ({
    ...state,
    allRoles: {
      items: payload,
      error: null,
      loading: false,
    },
  }),

  [FetchAllRoles.Error.TYPE]: (state: ICommon, { payload }: AnyAction) => ({
    ...state,
    allRoles: {
      items: [],
      error: payload,
      loading: false,
    },
  }),

  [FetchAllGroups.Error.TYPE]: (state: ICommon, { payload }: AnyAction) => ({
    ...state,
    allGroups: {
      items: [],
      error: payload,
      loading: false,
    },
  }),
  [CloseGroupsGeneralNetworkErrorBanner.TYPE]: (state: ICommon) => ({
    ...state,
    allGroups: {
      ...state.allGroups,
      error: null,
    },
  }),

  [FetchFeatureFlags.Success.TYPE]: (
    state: ICommon,
    { payload }: AnyAction
  ) => ({
    ...state,
    featureFlags: payload,
    featureFlagsRetrieved: true,
  }),

  [SetCurrentUserId.TYPE]: (state: ICommon, { payload }: AnyAction) => ({
    ...state,
    auth: {
      ...state.auth,
      userId: payload,
    },
  }),
});
